export default "__VITE_ASSET__B0jH5_sA__"